import MarkdownGithub from "components/markdown/MarkdownGithub";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";

import ModuleVersionScrollableWrapper from "../components/ScrollableWrapper";
import ModuleVersionPageIntoTitle from "../components/PageIntoTitle";

type ModuleVersionChangelogProps = {
  content: string | undefined;
};

const ModuleVersionChangelog = ({ content }: ModuleVersionChangelogProps) => {
  return (
    <>
      <PageInfoHeaderWrapper>
        <ModuleVersionPageIntoTitle
          title="Changelog"
          tooltip="Module's changelog generated by your CHANGELOG.md file."
        />
      </PageInfoHeaderWrapper>
      <ModuleVersionScrollableWrapper surfaceColor="primary">
        <MarkdownGithub markup={content || "No changelog available"} />
      </ModuleVersionScrollableWrapper>
    </>
  );
};

export default ModuleVersionChangelog;
